export const wintextObj: any = {
    us: {
        titlea1: 'Trouble finding your Super Early Bird coupon code? ',
        titlea2: 'Click here',
        titlea3: ' to check your code.',
        titleb: 'Or contact our customer service to redeem the EXCLUSIVE codes.',
        win_title: 'Fill in your details to check your code',
        win_placeholder1: '*Order name',
        win_placeholder2: '*Order email address',
        win_error_email: 'Please enter a valid email.',
        win_submit: 'Submit',
        win_tipa1: '1. What is the order name?',
        win_tipa2: 'The order name is a 10-character combination of letters and numbers: EFUS-XXXXXX.',
        win_tipa2_ca: 'The order name is a 10-character combination of letters and numbers: EFCA-XXXXXX.',
        win_tipb1: '2. Where can I locate my order name?',
        win_fail_tips: 'Sorry,we cannot find your order.',
        win_tipb2: 'You can find your order name on the order confirmation page or in the email you receive after making a purchase.',
        win2_title: 'Your Code Number is :',
        win2_desc: 'EFUS-XXXXXX',
        win_quote_float: 'Get a Free Quote',
        win_quote_title: "We're Here to Help",
        win_quote_desc: 'Fill out the form below or call us: <a href="tel:+1(800)-366-8604">+1(800)-366-8604 Mon-Fri 9 am-7pm(EST)</a>',
        win_quote_desc2: 'Fill out the form below or call us: <a href="tel:+12318887164">+1 231-888-7164 Mon-Fri 9 am-7pm(EST)</a>',
        win_quote_f1: 'We will be in touch with you in 3 working days.',
        win_quote_success1: 'success',
        win_quote_success2: 'Your submission has been successfully received. Our experts will contact you via email within 3 working days.',

        win_simple_title: 'Get Expert Help',
        win_simple_desc:
            "From costs to setup and beyond, an EcoFlow expert is on hand to answer all your questions. Just provide your information below and we'll get back to you within 3 business days.",
        win_quote_simple_f1: 'For further assistance:',
        win_quote_simple_f2: '+1(800)-368-8604   Mon-Fri 9 am-9 pm (EST)',
    },
    jp: {
        win_quote_float: 'お問い合わせ',
    },
};
